"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionTakingContainer = void 0;
const adaptivecards_1 = require("adaptivecards");
const QuestionSettingsInfoBar_1 = require("../../survey/components/QuestionSettingsInfoBar");
const CardHelper_1 = require("../utils/CardHelper");
const QuestionInputElement_1 = require("./QuestionInputElement");
function questionTakingContainer(question, index, options, value, commentValue) {
    const container = new adaptivecards_1.Container();
    container.spacing = adaptivecards_1.Spacing.Medium;
    container.customCssSelector = "question-container";
    container.style = adaptivecards_1.ContainerStyle.Emphasis;
    if (!options.hideTitle) {
        container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: options.hideQuestionIndex ? question.label : `Q${index}: ${question.label}`,
            weight: adaptivecards_1.TextWeight.Bolder,
            color: adaptivecards_1.TextColor.Accent,
            size: adaptivecards_1.TextSize.Medium,
            wrap: true,
        }));
        if (!options.hideSettingsBar) {
            const optionList = (0, QuestionSettingsInfoBar_1.QuestionSettingsInfoBar)(question, options.highlightRequired);
            if (optionList) {
                container.addItem(optionList);
            }
        }
    }
    let defaultValue;
    if (value) {
        if (typeof value === "string") {
            defaultValue = value;
        }
        else if (value instanceof Array) {
            defaultValue = value.join(",");
        }
    }
    container.addItem((0, QuestionInputElement_1.getQuestionElement)(question, defaultValue, commentValue));
    return container;
}
exports.questionTakingContainer = questionTakingContainer;
//# sourceMappingURL=QuestionTakingContainer.js.map